import { showConfirmDialog } from '@/services/messages/dialog-manager'
import { extractActionScriptText } from '@/services/action/normalizeActionTransfer'
import { t } from '@/common/utils/translations'

/** Текст `<confirm>` из action-узла формы или plain string. */
export function readActionConfirmMessage(actionOrConfirm: unknown): string {
  if (actionOrConfirm == null) return ''
  if (typeof actionOrConfirm === 'string') return actionOrConfirm.trim()
  const record = actionOrConfirm as { confirm?: unknown }
  if ('confirm' in record) {
    return extractActionScriptText(record.confirm)
  }
  return extractActionScriptText(actionOrConfirm)
}

/**
 * Единый async-confirm для platform action (PrimeVue).
 * Пустой текст — сразу true. UI не показывается в coreService.elementAction.
 * TODO: сейчас нужен для выполнения legacy action (мимо executeAction), должен вызываться только там
 */
export async function confirmPlatformAction(message: unknown): Promise<boolean> {
  const text =
    typeof message === 'string' ? message.trim() : readActionConfirmMessage(message)
  if (!text) return true

  return showConfirmDialog({
    title: t('dialogs.confirmOperation'),
    message: text,
    // Swing: showConfirmDialog(..., OK_CANCEL_OPTION, QUESTION_MESSAGE)
    iconClass: 'pi pi-question',
    buttons: [
      { type: 'cancel', label: t('dialogs.cancel'), severity: 'secondary' },
      { type: 'confirm', label: t('dialogs.ok') },
    ],
  })
}
